<template>
  <v-card class="card-border">
    <highcharts :options="chartOptions" />
  </v-card>
</template>

<script>
import { Chart } from "highcharts-vue";
import { mapGetters } from "vuex";

export default {
  name: "Metas",

  components: {
    highcharts: Chart
  },

  data() {
    return {
      chartOptions: {
        chart: {
          type: "column"
        },
        title: {
          text: ""
        },
        xAxis: {
          categories: ["Consorcio", "Novos", "Usados"],
          crosshair: true
        },
        yAxis: {
          min: 0,
          title: {
            text: "Quantidade"
          }
        },
        tooltip: {
          headerFormat:
            '<span style="font-size:10px">{point.key}</span><table>',
          pointFormat:
            '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
            '<td style="padding:0"><b>{point.y}</b></td></tr>',
          footerFormat: "</table>",
          shared: true,
          useHTML: true
        },
        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0
          }
        },
        series: [
          {
            name: "Realizado",
            data: []
          },
          {
            name: "Meta",
            data: []
          }
        ],
        colors: ['#88D956', '#2CB2AD']
      }
    };
  },

  computed: {
    ...mapGetters("dashboard", ["getDesempenho"])
  },

  methods: {
    generateGrafic(desempenho) {
      this.chartOptions.series[1].data.push(desempenho.metaConsorcios);
      this.chartOptions.series[1].data.push(desempenho.metaNovos);
      this.chartOptions.series[1].data.push(desempenho.metaUsados);

      this.chartOptions.series[0].data.push(desempenho.p1.qtd);
      this.chartOptions.series[0].data.push(desempenho.novos.qtd);
      this.chartOptions.series[0].data.push(desempenho.usados.qtd);
    },

    formatTitle(desempenho) {
      let date = new Date(desempenho.dataFim.seconds * 1000);
      date.setMonth(date.getMonth());
      let mes = date.toLocaleString("default", { month: "long" })
      mes = mes.charAt(0).toUpperCase() + mes.slice(1)
      this.chartOptions.title.text = `Metas de ${mes}`;
    },

    clearGrafic() {
      this.chartOptions.series[0].data = []
      this.chartOptions.series[1].data = []
    }
  },

  watch: {
    getDesempenho(desempenho) {
      this.clearGrafic()
      this.formatTitle(desempenho)
      this.generateGrafic(desempenho);
    }
  },

  mounted() {
    if (this.getDesempenho.length !== 0) {
      this.clearGrafic()
      this.formatTitle(this.getDesempenho)
      this.generateGrafic(this.getDesempenho);
    }
  }
};
</script>
